import { COMMERCIAL_CLASS_NAME } from './constants';
import { IOffer } from '../../../types/offer';

export function getCommercialBuildingClass(offer: IOffer): string | undefined {
  const classType = offer.building?.classType ?? offer.businessShoppingCenter?.buildingClassType;

  if (!classType) {
    return undefined;
  }

  const name = COMMERCIAL_CLASS_NAME.get(classType);

  return name ? `Класс ${name}` : undefined;
}
